"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tapis Workflows API
 * Create and manage pipelines
 *
 * The version of the OpenAPI document: 1.2.0
 * Contact: cicsupport@tacc.utexas.edu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require("./");
function ReqContextFromJSON(json) {
    return ReqContextFromJSONTyped(json, false);
}
exports.ReqContextFromJSON = ReqContextFromJSON;
function ReqContextFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['type']) {
        case _1.EnumContextType.Dockerhub:
            return __assign({}, _1.ReqDockerhubContextFromJSONTyped(json, true), { type: _1.EnumContextType.Dockerhub });
        case _1.EnumContextType.Github:
            return __assign({}, _1.ReqGithubContextFromJSONTyped(json, true), { type: _1.EnumContextType.Github });
        case _1.EnumContextType.Gitlab:
            return __assign({}, _1.ReqGitlabContextFromJSONTyped(json, true), { type: _1.EnumContextType.Gitlab });
        case _1.EnumContextType.Local:
            return __assign({}, _1.ReqLocalContextFromJSONTyped(json, true), { type: _1.EnumContextType.Local });
        default:
            throw new Error("No variant of ReqContext exists with 'type=" + json['type'] + "'");
    }
}
exports.ReqContextFromJSONTyped = ReqContextFromJSONTyped;
function ReqContextToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['type']) {
        case _1.EnumContextType.Dockerhub:
            return _1.ReqDockerhubContextToJSON(value);
        case _1.EnumContextType.Github:
            return _1.ReqGithubContextToJSON(value);
        case _1.EnumContextType.Gitlab:
            return _1.ReqGitlabContextToJSON(value);
        case _1.EnumContextType.Local:
            return _1.ReqLocalContextToJSON(value);
        default:
            throw new Error("No variant of ReqContext exists with 'type=" + value['type'] + "'");
    }
}
exports.ReqContextToJSON = ReqContextToJSON;
